import { useState, useEffect } from "react";
import { API_BASE } from "@config/env";
import axios from "axios";
import SectionCard from "./SectionCard";

const post = (ep, f) => {
  const fd = new FormData();
  Object.entries(f).forEach(([k,v]) => fd.append(k,v));
  return axios.post(`${API_BASE}${ep}`, fd).then(r=>r.data).catch(()=>null);
};

export default function RecommendHistoryTab({ resourceSlug }) {
  const [items,   setItems]   = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    post("get-recommendation-history", { resource_slug: resourceSlug })
      .then(d => {
        setItems(Array.isArray(d?.history||d?.data) ? (d.history||d.data) : []);
        setLoading(false);
      });
  }, [resourceSlug]);

  return (
    <SectionCard title="Recommendation History">
      {loading
        ? <div style={{textAlign:"center",color:"var(--fc-text-subtle)",padding:"24px 0"}}><i className="fa-solid fa-spinner fa-spin"/></div>
        : items.length === 0
          ? <div style={{color:"var(--fc-text-subtle)",fontSize:13,textAlign:"center",padding:"24px 0"}}>No recommendations sent yet.</div>
          : items.map((r,i) => (
              <div key={r.id||i} style={{padding:"12px 14px",background:"var(--fc-bg-light)",border:"1px solid var(--fc-border)",borderRadius:10,marginBottom:8}}>
                <div style={{fontSize:13,fontWeight:700,color:"var(--fc-text-primary)"}}>{r.client_name||r.to_name}</div>
                {r.subject && <div style={{fontSize:12,color:"var(--fc-text-muted)",marginTop:2}}>{r.subject}</div>}
                {r.sent_on  && <div style={{fontSize:11,color:"var(--fc-text-subtle)",marginTop:4}}>{r.sent_on}</div>}
              </div>
            ))
      }
    </SectionCard>
  );
}
